import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-log',
  templateUrl: './sms-log.component.html',
  styleUrls: ['./sms-log.component.scss']
})
export class SmsLogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
